import Api from '../../api'
import { default as normalizeContractProperties } from 'portal-modules/auth/api/normalize-contract-properties'
import { call, put, takeLatest } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'

// action types
const REQUEST_CONTRACTS = 'rp/contracts/REQUEST_CONTRACTS'
const RECEIVE_CONTRACTS = 'rp/contracts/RECEIVE_CONTRACTS'
export const RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS =
  'rp/contracts/RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS'

// reducer
export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS:
      return action.payload.contracts
    case RECEIVE_CONTRACTS:
      return action.payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestContracts = () => ({
  type: REQUEST_CONTRACTS,
})

// sagas
function* fetchContracts() {
  const { group_contracts } = yield call(Api.getContracts)
  if (group_contracts.length > 0) {
    const { contracts, properties } = normalizeContractProperties(
      group_contracts,
    )
    yield put(receiveContractPropertyAssociations({ contracts, properties }))
  }
}

export const receiveContractPropertyAssociations = payload => ({
  type: RECEIVE_CONTRACT_PROPERTY_ASSOCIATIONS,
  payload,
})

export const receiveContracts = payload => ({
  type: RECEIVE_CONTRACTS,
  payload,
})

function* watchRequestContracts() {
  yield takeLatest(
    REQUEST_CONTRACTS,
    createRequestSaga(fetchContracts, {
      key: 'contracts',
      message: __('Finding contracts'),
    }),
  )
}

export const sagas = [watchRequestContracts]
